module.exports = __webpack_public_path__ + "adobe.ea75b030f63774149f260dd373f3da2d.png";